import React from "react";
import {
	Frame,
	Container,
	Intro,
	IntroText,
	NextIntro,
	NextIntroItem,
} from "./styles";
import VoiceLead from "@src/components/VoiceLead";
import VoiceIntroImage from "@src/components/VoiceIntroImage";
import Tail from "../VoiceItem/Tail";
import ArticleNode from "./ArticleNode";
import ArticleImageColumn from "./ArticleImageColumn";
import { Props as ArticleNodeProp } from "./ArticleNode";
import { GatsbyImageProps } from "gatsby-plugin-image";
import { useWindowSize } from "@src/utils/useWindowSize";

export interface Article {
	type: "full" | "column";
	reverse: boolean;
	img?:
		| React.ReactElement<HTMLImageElement>
		| React.FunctionComponent<GatsbyImageProps>;
	content?: ArticleNodeProp[];
}
export interface Props {
	voiceInfo: {
		voiceNumber: number;
		voiceType: string;
		lead: string;
		staffInfo: {
			name: string;
			position: string;
			ruby: string;
		}[];
		listImg:
			| React.ReactElement<HTMLImageElement>
			| React.FunctionComponent<GatsbyImageProps>;
		img:
			| React.ReactElement<HTMLImageElement>
			| React.FunctionComponent<GatsbyImageProps>;
	};
	article: Article[];
	nextVoiceInfo?: {
		voiceNumber: number;
		voiceType: string;
		lead: string;
		staffInfo: {
			name: string;
			position: string;
			ruby: string;
		}[];
		listImg:
			| React.ReactElement<HTMLImageElement>
			| React.FunctionComponent<GatsbyImageProps>;
		img:
			| React.ReactElement<HTMLImageElement>
			| React.FunctionComponent<GatsbyImageProps>;
		updateFunc: () => void;
	};
	isVisible?: boolean;
	className?: string;
}
const VoiceDetail: React.FC<Props> = (props) => {
	const { voiceInfo, nextVoiceInfo, article, isVisible, className } = props;
	const { width: windowW } = useWindowSize();
	return (
		<Frame className={className}>
			<Container windowW={windowW}>
				<Intro>
					<IntroText>
						<VoiceLead
							lead={voiceInfo.lead}
							voiceNumber={voiceInfo.voiceNumber}
							voiceType={voiceInfo.voiceType}
							staffInfo={voiceInfo.staffInfo}
						/>
						<Tail direction="fromBottom" />
					</IntroText>
					<VoiceIntroImage img={voiceInfo.listImg} />
				</Intro>
				{article.map((val, index) =>
					val.type == "full" ? (
						!val.content ? (
							<ArticleImageColumn
								img={val.img}
								key={`articleImageColumn${index}`}
							/>
						) : (
							val.content.map((node, nodeIndex) => (
								<ArticleNode
									type={node.type}
									text={node.text}
									name={node.name}
									key={`articleNode${index}-${nodeIndex}`}
								/>
							))
						)
					) : (
						<ArticleImageColumn
							reverse={val.reverse}
							img={val.img}
							key={`articleImageColumn${index}`}
						>
							{val.content &&
								val.content.map((contentNode: ArticleNodeProp, nodeIndex) => (
									<ArticleNode
										type={contentNode.type}
										text={contentNode.text}
										name={contentNode.name}
										key={`articleNode${index}-${nodeIndex}`}
									/>
								))}
						</ArticleImageColumn>
					)
				)}
			</Container>
			{nextVoiceInfo && (
				<NextIntro onClick={nextVoiceInfo.updateFunc}>
					<NextIntroItem windowW={windowW}>
						<VoiceLead
							lead={nextVoiceInfo.lead}
							voiceNumber={nextVoiceInfo.voiceNumber}
							voiceType={nextVoiceInfo.voiceType}
							staffInfo={nextVoiceInfo.staffInfo}
							isListItem={true}
						/>
						<VoiceIntroImage img={nextVoiceInfo.listImg} />
					</NextIntroItem>
				</NextIntro>
			)}
		</Frame>
	);
};

export default VoiceDetail;
